import cn from 'clsx'
import get from 'lodash/get'

import React from 'react'
import { Link } from 'react-router-dom'
import type { Contact, RecipientList } from 'types/list'
import { parseSearchQuery } from '@disco/utils/string-utils'
import ActionButton from 'components/ui/action-button'
import HighlighedText from 'components/ui/highlighted-text'
import Input from 'components/ui/input' // TODO: Needs better naming and refactoring

class DefaultRow extends React.Component<{
  // TODO: Fix type
  columns: any
  list: RecipientList | null | undefined
  appendingContacts?: boolean
  contact: Contact
  searchTerm?: string
  saving?: boolean
  onRowModeSwitch: ((...args: Array<any>) => any) | null | undefined
  onFieldChange: ((...args: Array<any>) => any) | null | undefined
  onFieldValueAdd: ((...args: Array<any>) => any) | null | undefined
  onFieldValueRemove: ((...args: Array<any>) => any) | null | undefined
  // onSelect: ?Function,
  batchMode?: boolean | null | undefined
}> {
  render(): React.ReactElement<'div'> {
    const {
      columns,
      contact,
      searchTerm,
      onFieldChange,
      saving,
      appendingContacts,
      batchMode,
      onRowModeSwitch,
    } = this.props

    const getPendingChangesValue = (key: string) =>
      get(contact, `pendingChanges.${key}`, contact[key] || '')

    const isEditable = ({ editable, batchEditable }) =>
      batchEditable === false ? editable && !batchMode : editable

    const className = cn('ContactRow', {
      'is-selected': !!contact.selected,
    })
    const searchTerms = parseSearchQuery(searchTerm)
    return (
      <div
        className={cn(className, {
          'ContactRow--edit-mode': contact.editMode,
        })}
      >
        {columns.map(column => {
          if (!column) return null
          const key = `row-${column.label}`
          const className = `ContactCell ContactCell_${column.value}`
          return (
            <div key={key} className={className}>
              {contact.editMode && onFieldChange && isEditable(column) ? (
                <Input
                  className="Form_Input"
                  name={column.id}
                  value={getPendingChangesValue(column.id)}
                  onChange={e =>
                    onFieldChange(contact, e.target.name, e.target.value)
                  }
                />
              ) : column.renderData ? (
                column.renderData(contact)
              ) : (
                <Link
                  className="ContactCell_Link"
                  to={`/contacts/${contact.id}`}
                >
                  <HighlighedText
                    text={contact[column.id]}
                    highlights={searchTerms}
                  />
                </Link>
              )}
            </div>
          )
        })}
        {onRowModeSwitch && (
          <div className="ContactCell ContactCell_Action">
            <ActionButton
              disabled={Boolean(contact.referenced_business)}
              size="24px"
              icon="pen"
              activeIcon="check-circle"
              activeIconColor="#5f63ee"
              activeMode={contact.editMode}
              inProgressMode={contact.editMode && saving}
              inProgressIcon="spinner"
              inProgressColor="#ccc"
              onClick={() => onRowModeSwitch(contact, false)}
            />
          </div>
        )}
      </div>
    )
  }
}

export default DefaultRow
